import React, { useEffect, useState } from "react";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { AiFillCloseCircle } from "react-icons/ai";
import { Spinner } from "reactstrap";
import moment from "moment";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { getFormatedDate } from "../../../../../views/pages/manage/unAssigned/concessionApproval/common";


export const statusStyles = {
  "IN_PROGRESS": { bgColor: "#FFEDC8", textColor: "#705010", text: "In progress" },
  "SUCCESS": { bgColor: "#BBE2CE", textColor: "#0B442D", text: "Processed" },
  "REJECTED": { bgColor: "#F9D9D7", textColor: "#B32306", text: "Rejected" },
}

const TransferHistoryModal = ({ psid }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getTransferHistory = async () => {
    try {
      setLoading(true);
      const url = `${endpoint.studentTransfer.transferHistory
        }?psid=${psid}`;
      const res = await fetchAllPromisedData(url);
      if (res?.length) {
        setData(res);
      }
      //  else {
      //   failureToast("No transfer history found.");
      // }
    } catch (err) {
      failureToast("Failed to fetch transfer history.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (psid) getTransferHistory();
  }, [psid]);

  const columns = [
    new AGridColDef("psid", "PSID", false).setFlex(1),
    new AGridColDef("transferType", "Transfer Type", false).setFlex(0.8),

    new AGridColDef("createdOn", "Created On", false)
      .setFlex(1.3)
      .setValueGetter((params) => {
        const dateAndTime = getFormatedDate(params?.value, false, "DD/MM/YYYY,hh:mm:A")?.split(",");
        return params?.value ? `${dateAndTime[0]} at ${dateAndTime[1]}` : "-";
      }),

    new AGridColDef("updatedOn", "Last Updated On", false)
      .setFlex(1.3)
      .setValueGetter((params) => {
        const dateAndTime = getFormatedDate(params?.value, false, "DD/MM/YYYY,hh:mm:A")?.split(",");
        return params?.value ? `${dateAndTime[0]} at ${dateAndTime[1]}` : "-";
      }),

    new AGridColDef("transferStatus", "Status", false)
      .setFlex(1)
      .renderCellComponent((params) => (
        <CustomChip
          className="text-wrap mt-1 w-100 text-center"
          {...statusStyles[params.value]}
        />

      )),
  ];



  return (
    <div className="p-3" style={{ minWidth: "740px" }}>
      <ADataGrid
        rows={data}
        columns={columns}
        loading={loading}
        rowId={(row) => row?.id || row?.psid}
        autoHeight
        disableSelectionOnClick
        hideFooterPagination
        sx={{ border: "1px solid #dee2e6", borderRadius: "4px" }}
        noRowsOverlayMessage={
          loading ? (
            <div className="text-center py-3">
              <Spinner size="sm" color="primary" /> Loading...
            </div>
          ) : (
            "No transfer history found."
          )
        }
      />
    </div>
  );
};

export default TransferHistoryModal;
